import { handleActions } from "redux-actions";

const dealStageAssetReducer = handleActions(
  {
    DEAL_STAGE_ASSETS_GET: {
      FULFILLED: (_, { payload }) => ({
        dealStageAssets: payload.dealStageAssets,
      }),
    },

    DEAL_STAGE_ASSETS_CREATE: {
      FULFILLED: ({ dealStageAssets }, { payload }) => ({
        dealStageAssets: [...dealStageAssets, payload.dealStageAsset],
      }),
    },

    DEAL_STAGE_ASSETS_DELETE: {
      FULFILLED: ({ dealStageAssets }, { meta }) => {
        console.log({ meta });

        return {
          dealStageAssets: dealStageAssets.filter(
            (dealStageAsset) => dealStageAsset.id !== meta.dealStageAssetID
          ),
        };
      },
    },
  },
  {},
  { namespace: "_" }
);

export default dealStageAssetReducer;
